"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformWorkspaceProjectDeletedEventResourceToJSON = exports.transformJSONToWorkspaceProjectDeletedEventResource = void 0;

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformWorkspaceProjectDeletedEventResourceToJSON = function transformWorkspaceProjectDeletedEventResourceToJSON(value) {
  return {
    id: value.id,
    type: value.type
  };
};

exports.transformWorkspaceProjectDeletedEventResourceToJSON = transformWorkspaceProjectDeletedEventResourceToJSON;

var transformJSONToWorkspaceProjectDeletedEventResource = function transformJSONToWorkspaceProjectDeletedEventResource(value) {
  return {
    id: value.id,
    type: value.type
  };
};
/**
 * 
 * @export
 * @interface WorkspaceProjectDeletedEventResource
 */


exports.transformJSONToWorkspaceProjectDeletedEventResource = transformJSONToWorkspaceProjectDeletedEventResource;